"use client";

import { styled } from "@mui/material";

const LogoImage = styled("img")({
  width: "240px",
});

export default function Logo() {
  return <LogoImage src="/img/floats-colour.svg" alt="Floats" />;
}
